import { LAMPORTS_PER_SOL } from '@solana/web3.js'

export async function userSOLBalance(publicKey, connection) {
	let balance = 0;
	try {
		balance = await connection.getBalance(
			publicKey,
			'confirmed'
		);
		balance = balance / LAMPORTS_PER_SOL;
	} catch (e) {
		console.log(`error getting balance: `, e);
	}
	
	return balance;
}